module.exports = __webpack_public_path__ + "img/hz.75f12d20.png";